import api from 'api/axiosInstance';
import type { CurrenciesEnum } from 'types/global.types';
import type { Transaction } from 'types/transactions.types';

type SimilarTransactionBody = {
  amount: number;
  currency: CurrenciesEnum;
  fromIBAN: string;
  toIBAN: string;
};

type SimilarTransctionResponse = {
  hasSimilarTransaction: boolean;
  similarTransaction: Transaction;
};

const getSimilarTransaction = (
  body: SimilarTransactionBody,
): Promise<SimilarTransctionResponse> =>
  api.get('/v2/transactions/similar', { params: body });

export default getSimilarTransaction;
